/* unplugin-vue-components disabled */import script from "./App_pc.vue?vue&type=script&setup=true&lang=js"
export * from "./App_pc.vue?vue&type=script&setup=true&lang=js"

import "./App_pc.vue?vue&type=style&index=0&id=19113a4a&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19113a4a"]])

export default __exports__